angular.module('iconoglobe').directive('imgLoad', [function(){
  return {
    link: function(scope, element) {
      element.on('load', function() {
        scope.promotionImageLoaded('image');
      });
    }
  }
}])